/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */

export const ActionComponentTypename = 'com.hubspot.ai.agent.models.core.ActionComponent';
export const AgentComponentTypename = 'com.hubspot.ai.agent.models.core.AgentComponent';
export const AgentTemplateComponentTypename = 'com.hubspot.ai.agent.models.core.AgentTemplateComponent';
export const AviatorAgentComponentTypename = 'com.hubspot.ai.agent.models.core.AviatorAgentComponent';
export const BooleanAgentInputTypename = 'com.hubspot.ai.agent.models.core.BooleanAgentInput';
export const BuiltInToolComponentTypename = 'com.hubspot.ai.agent.models.core.BuiltInToolComponent';
export const ChirpRpcComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpRpcComponent';
export const ChirpToolBundleComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpToolBundleComponent';
export const CrmObjectCoordinatesAgentInputTypename = 'com.hubspot.ai.agent.models.core.CrmObjectCoordinatesAgentInput';
export const FileAgentInputTypename = 'com.hubspot.ai.agent.models.core.FileAgentInput';
export const FilesAgentInputTypename = 'com.hubspot.ai.agent.models.core.FilesAgentInput';
export const HookComponentTypename = 'com.hubspot.ai.agent.models.core.HookComponent';
export const KnowledgeBoxComponentTypename = 'com.hubspot.ai.agent.models.core.KnowledgeBoxComponent';
export const ListAgentInputTypename = 'com.hubspot.ai.agent.models.core.ListAgentInput';
export const MapAgentInputTypename = 'com.hubspot.ai.agent.models.core.MapAgentInput';
export const McpServerComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerComponent';
export const McpServerV2ComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerV2Component';
export const NullAgentInputTypename = 'com.hubspot.ai.agent.models.core.NullAgentInput';
export const NumberAgentInputTypename = 'com.hubspot.ai.agent.models.core.NumberAgentInput';
export const SkillComponentTypename = 'com.hubspot.ai.agent.models.core.SkillComponent';
export const StringAgentInputTypename = 'com.hubspot.ai.agent.models.core.StringAgentInput';
export const WebhookComponentTypename = 'com.hubspot.ai.agent.models.core.WebhookComponent';
export const FindActionUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindActionUsageRequest';
export const FindBuiltInToolUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindBuiltInToolUsageRequest';
export const FindChirpRpcUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindChirpRpcUsageRequest';
export const FindKnowledgeBoxUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindKnowledgeBoxUsageRequest';
export const FindMcpUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindMcpUsageRequest';

/**
 *  Represents a validation error for a specific component (action, knowledge box, etc.).
 *  This structured format allows the frontend to construct user-facing error messages.
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const getAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYgW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByIDsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByIDs',
  auth: 'app',
  fingerprint: 'v_Hi8JpYU3hCaKnLW5cJNhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesWithSnapshotsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesWithSnapshots',
  auth: 'app',
  fingerprint: '9QKX_6KF_GEporZVJVNm1RDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByWorkflowIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByWorkflowId',
  auth: 'app',
  fingerprint: 'jhR4yXLMTW0XahMB2eyPthDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByStatusRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByStatus',
  auth: 'app',
  fingerprint: 'VItEKjqHl_f3tasx57mKpRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getActiveAgentInstances',
  auth: 'app',
  fingerprint: 'tt8k1TqizUb3tasx57mKpRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstances',
  auth: 'app',
  fingerprint: 'FM9XVOlqZyz3tasx57mKpRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'searchAgentInstances',
  auth: 'app',
  fingerprint: 'YA5lK2Rcr5b3tasx57mKpRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createAgentInstance',
  auth: 'app',
  fingerprint: '2ObJAV9QUepM8G3vwRm_1hDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstance',
  auth: 'app',
  fingerprint: '3m_mdw5BWTEW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV2',
  auth: 'app',
  fingerprint: '3m_mdw5BWTEW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const patchAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'patchAgentInstance',
  auth: 'app',
  fingerprint: 'P0fYBPAlHNMW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const factoryResetRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'factoryReset',
  auth: 'app',
  fingerprint: 'luxHuQpJJYgW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const factoryResetV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'factoryResetV2',
  auth: 'app',
  fingerprint: 'o0RYNvpITsUW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resetToLatestTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'resetToLatestTemplate',
  auth: 'app',
  fingerprint: 'Im2kC-4d0BvjmKCEz5KkGhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYhzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstanceV2',
  auth: 'app',
  fingerprint: 'bquNPpxFM9hzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplate',
  auth: 'app',
  fingerprint: 'xkTDli_zI7pnR5sE-n31pBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplateByGlobalId',
  auth: 'app',
  fingerprint: '8T0SVgHu08pnR5sE-n31pBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentInstance',
  auth: 'app',
  fingerprint: '6Q3FXpGQ29lnR5sE-n31pBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentsForFlowRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentsForFlow',
  auth: 'app',
  fingerprint: 'LVwvv72TyJmHV3CCm_HtxRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByTemplateIdsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByTemplateIds',
  auth: 'app',
  fingerprint: 'Bao0fja8a34gaY9ARh1tjxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByGlobalId',
  auth: 'app',
  fingerprint: 'yPtD4Qwpkj9TnVGhCd97uRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uploadFilesToAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'uploadFilesToAgentInstance',
  auth: 'app',
  fingerprint: '4YA1yvjO9UQW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findComponentUsageRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'findComponentUsage',
  auth: 'app',
  fingerprint: 'Vivm1MorVsTYT3KwyiBECxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceOwnerRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceOwner',
  auth: 'app',
  fingerprint: 'biKggbtMJGFzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'vxmtmtyT79wW3IPaks60_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneInstanceFromSnapshot',
  auth: 'app',
  fingerprint: '5_egGuqK0dlnR5sE-n31pBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitPromptFeedbackRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'submitPromptFeedback',
  auth: 'app',
  fingerprint: 'oe59OesdG8tzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadiness',
  auth: 'app',
  fingerprint: 'xxUFVM1ASUtHKNNd4MLGeBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadinessV2',
  auth: 'app',
  fingerprint: '_y3TSpR__PPlnnLyhTfIORDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkValidateAgentInstancesReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkValidateAgentInstancesReadiness',
  auth: 'app',
  fingerprint: 'ate6fB_EofplU4ciiiItdhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstances',
  auth: 'app',
  fingerprint: 'xPk4_njx_-rRK-Fh0MHxwxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesByKeyRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstancesByKey',
  auth: 'app',
  fingerprint: 'NnWw52-6Crj3kIoxJvzA_xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkUpdateAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkUpdateAgentInstances',
  auth: 'app',
  fingerprint: 'P5lIvxL7Ao8jjAGCl7Ez-xDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkSoftDeleteAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkSoftDeleteAgentInstances',
  auth: 'app',
  fingerprint: 'lQSah62WeHRlIE2fHG1QwxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentConnectionsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentConnections',
  auth: 'app',
  fingerprint: 'L5P9kdUDyVuiFXWnWHuO5hDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};